define('viewmodels/survey/BlueprintSetup',['knockout', 'plugins/router', 'services/navigation', 'services/logger', 'durandal/app', 'durandal/system', 'services/appsecurity', 'viewmodels/GeneralSettings', 'services/utils'],
    function (ko, router, navigation, logger, app, system, appsecurity, ObjGeneralSettings, utils) {
        var BpViewModel = {
            attached: attached,
            detached: detached,
            activate: activate,
            utils: utils,
            appsecurity: appsecurity,
            ObjGeneralSettings: ObjGeneralSettings,
            ControlsAccess: ko.observable(false),

            // Blueprint Filter - Starts
            AssessmentTypeListDropDown: ko.observableArray(),
            SurveyCategoryListDropDown: ko.observableArray(),
            MatrixTypeListDropDown: ko.observableArray(),
            BusinessUnitListDropDown: ko.observableArray(),
            AreasListDropDown: ko.observableArray(),
            SelectedAssessmentValue: ko.observable(),
            SelectedAssessmentValueName: ko.observable(),
            SelectedCategoryValue: ko.observable(),
            SelectedCategoryValueName: ko.observable(),
            SelectedMatrixType: ko.observable(),
            SelectedMatrixTypeName: ko.observable(),
            SelectedBUList: ko.observable(),
            SelectedAreaList: ko.observableArray(),
            SelectedQuestionList: ko.observableArray([]),
            onChangeAssessmentDropDown: onChangeAssessmentDropDown,
            onChangeSurveyCategoryDropDown: onChangeSurveyCategoryDropDown,
            onChangeMatrixTypeDropDown: onChangeMatrixTypeDropDown,
            ApplyBlueprintFilter: ApplyBlueprintFilter,
            // Blueprint Filter - Ends

            //Blueprint Excel - Starts
            downloadDocuments: downloadDocuments,
            uploadDownloadTemplate: uploadDownloadTemplate,
            uploadDocumentBtn: uploadDocumentBtn,
            //Blueprint Excel - Ends

            BlueprintDataList: ko.observableArray(),
            BusinessUnitList: ko.observableArray(),
            SubAreaList: ko.observableArray(),
            SubAreaListSelected: ko.observableArray(),
            PreviouslyValuesSet: ko.observable(),
            LocaleCheckFlag: ko.observable(false),

            ApplyBlueprintPopup: ApplyBlueprintPopup,
            consentCheck: consentCheck,
            applyBlueprintSetup: applyBlueprintSetup,
            NavigateToSSRSBPChangeReport: NavigateToSSRSBPChangeReport,
            OnChangeSurveyComponent: OnChangeSurveyComponent,
            IsLaunchedFlag: ko.observable(false),
            SelectedSurveyComponent: ko.observable(),
            SurveyTypesList: ko.observableArray([]),

            ObligationTabClick: ObligationTabClick,
            DimensionTabClick: DimensionTabClick,
            showDeleteExceptionRulePopup: showDeleteExceptionRulePopup,
            DimensionTypeClick: DimensionTypeClick,
            SelectedDimensionTypeId: ko.observable(),
            DimensionType: ko.observableArray([]),
            DimensionTypeX_Axis: ko.observable('Area(s)'),
            DimensionTypeY_Axis: ko.observable('Question'),
            DimensionTypeZ_Axis: ko.observable('Applicability'),
            DimensionClass: ko.observable(),
            ExceptionRuleList: ko.observableArray([]),
            AddRulePopUp: AddRulePopUp,
            SetExceptionRuleData: SetExceptionRuleData,
            XAxisList: ko.observableArray([]),
            YAxisList: ko.observableArray([]),
            ZAxisList: ko.observableArray([]),
            SupportingXAxisList: ko.observableArray([]),
            SupportingYAxisList: ko.observableArray([]),
            SupportingZAxisList: ko.observableArray([]),
            DimensionRAT: ko.observableArray([]),
            DimensionZAT: ko.observableArray([]),
            SupportDimensionTypeX_Axis: ko.observable(''),
            SupportDimensionTypeY_Axis: ko.observable(''),
            SupportDimensionTypeZ_Axis: ko.observable(''),
            SelectedExceptionAssessmentValue: ko.observable(),
            onChangeExceptionAssessmentDropDown: onChangeExceptionAssessmentDropDown,
            SelectedExceptionCategoryValue: ko.observable(),
            onChangeExceptionSurveyCategoryDropDown: onChangeExceptionSurveyCategoryDropDown,
            SelectedExceptionXAxisValue: ko.observableArray([]),
            onChangeExceptionXAxisDropDown: onChangeExceptionXAxisDropDown,
            SelectedExceptionSupportingYAxisValue: ko.observableArray([]),
            onChangeExceptionSupportingYAxisDropDown: onChangeExceptionSupportingYAxisDropDown,
            UniqueYAxisList: ko.observableArray([]),
            SelectedExceptionZAxis: ko.observable(),
            SelectedExceptionYAxis: ko.observable()
        };
        return BpViewModel;

        function activate() {
            try {
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: activate() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function attached() {
            try {
                if (appsecurity.isConfigurationFreeze() === undefined) {
                    appsecurity.GetConfigurationFreezeFlag().then(function () {
                        if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
                            BpViewModel.ControlsAccess(true);
                        }
                        else {
                            BpViewModel.ControlsAccess(false);
                        }
                    });

                    if (BpViewModel.ObjGeneralSettings === undefined || BpViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((BpViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || BpViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && BpViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                        BpViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                            if (BpViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || BpViewModel.ObjGeneralSettings.LocalizedTextList() == null || BpViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || BpViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || BpViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                                BpViewModel.LocaleCheckFlag(false);
                            else
                                BpViewModel.LocaleCheckFlag(true);
                        });
                    }
                    else {
                        if (BpViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || BpViewModel.ObjGeneralSettings.LocalizedTextList() == null || BpViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || BpViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || BpViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                            BpViewModel.LocaleCheckFlag(false);
                        else
                            BpViewModel.LocaleCheckFlag(true);
                    }
                }
                else if (appsecurity.WriteAccess() && !appsecurity.isConfigurationFreeze()) {
                    BpViewModel.ControlsAccess(true);
                }
                else {
                    BpViewModel.ControlsAccess(false);
                }
                GetAllSurveyType();
                $('#BlueprintTabDiv').tabs();
                $('#BlueprintTabDiv').tabs({ active: 0 });
                $($('#BlueprintTabs li').get(0)).trigger('click');
                $('#AddRuleBtn').hide();
                BpViewModel.BlueprintDataList([]);
                BpViewModel.BusinessUnitList([]);
                BpViewModel.SubAreaList([]);
                BpViewModel.SubAreaListSelected([]);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function detached() {
            try {
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        // Blueprint Filter - Starts
        function ObligationTabClick(data, event) {
            try {
                $('#BlueprintTabs li').removeClass('active');
                $('#ObligationMatrixTab').addClass('active');
                GetBlueprintFilterData();
                $('#ApplicableBUDropdown').multiselect();
                $('#ApplicableAreaDropdown').multiselect();
                $('#ObligationContent').show();
                $('#DimensionContent').hide();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: TabClick() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }
        function DimensionTabClick(data, event) {
            try {
                $('#BlueprintTabs li').removeClass('active');
                $('#DimensionTab').addClass('active');
                $('#ObligationContent').hide();
                $('#DimensionContent').show();
                $('#AddRuleBtn').hide();
                GetAllDimensionType();
                $('#DimensionExceptionTable').DataTable();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: TabClick() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function GetAllDimensionType() {
            try {
                $.ajax({
                    url: "/api/Configuration/GetAllDimensionType",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(function (jsonResult, error) {
                        BpViewModel.DimensionType([]);
                        if (jsonResult !== null) {
                            if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                                logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(BpViewModel), true);
                            }
                            else {
                                var MappedDimensionType = $.map(jsonResult, function (result) {
                                    return new DimensionTypeModel(result);
                                });
                                BpViewModel.DimensionType(MappedDimensionType);
                                BpViewModel.DimensionTypeX_Axis(MappedDimensionType[0].XAxisName());
                                BpViewModel.DimensionTypeY_Axis(MappedDimensionType[0].YAxisName());
                                BpViewModel.DimensionTypeZ_Axis(MappedDimensionType[0].ZAxisName());
                                BpViewModel.DimensionClass(MappedDimensionType[0].DimensionClass());
                                $('#DimensionsTypeTabDiv').tabs();
                                $('#DimensionsTypeTabDiv').tabs({ active: 0 });
                                $($('#DimensionsTypeTabDiv li').get(0)).trigger('click');
                            }
                        }
                        return true;
                    })
                    .fail(function (jsonResult, error) {
                        logger.logError((!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchDimensionType') == -1) ? (!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchDimensionType') == -1) ? 'An error has occurred while fetching the dimension types. Please contact your Administrator.' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchDimensionType')].Name() : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchDimensionType')].Name(), 'Error', system.getModuleId(BpViewModel), true);
                        return false;
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetAllDimensionType() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function DimensionTypeClick(data, event) {
            try {
                BpViewModel.SelectedDimensionTypeId(data.DimensionTypeId());
                BpViewModel.DimensionTypeX_Axis(data.XAxisName());
                BpViewModel.DimensionTypeY_Axis(data.YAxisName());
                BpViewModel.DimensionTypeZ_Axis(data.ZAxisName());
                BpViewModel.DimensionClass(data.DimensionClass());
                $('#DimensionsTypeTabDiv li').removeClass('active');
                $('#' + 'DType_' + BpViewModel.SelectedDimensionTypeId()).addClass('active');
                GetExceptions();
                GetDimensionDetails();
                $('#AddRuleBtn').show();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetBlueprintFilterData() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }
        function GetExceptions() {
            try {
                $.ajax({
                    url: "/api/Configuration/GetExceptionRuleData",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: {
                        "DimensionTypeId": BpViewModel.SelectedDimensionTypeId()
                    }
                })
                    .success(function (jsonResult, error) {
                        BpViewModel.ExceptionRuleList([]);
                        tableObj = $('#DimensionExceptionTable').DataTable();
                        tableObj.destroy();
                        $('#DimensionExceptionTable tbody tr').remove();
                        if (jsonResult !== null) {
                            if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                                logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(BpViewModel), true);
                            }
                            else {
                                var MappedExceptionRuleList = $.map(jsonResult, function (result) {
                                    return new ExceptionModel(result);
                                });
                                BpViewModel.ExceptionRuleList(MappedExceptionRuleList);
                                $('#DimensionExceptionTable').DataTable();
                            }
                        }
                        return true;
                    })
                    .fail(function (jsonResult, error) {
                        logger.logError((!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchTypeAssessments') == -1) ? (!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchTypeAssessments') == -1) ? 'An error has occurred while fetching the type assessments. Please contact your Administrator.' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchTypeAssessments')].Name() : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchTypeAssessments')].Name(), 'Error', system.getModuleId(BpViewModel), true);
                        return false;
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetExceptions() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function showDeleteExceptionRulePopup(data, event) {
            try {
                app.showMessage("Are you sure you want to delete this Exception?", "Delete Exception", ["Confirm", "Cancel"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })

                    .then(function (option) {
                        if (option === 'Confirm') {
                            DeleteExceptionRule(data);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: showDeleteExceptionRulePopup() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }
        function DeleteExceptionRule(data) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/DeleteExceptionRule?ExceptionId=" + data.ExceptionId(),
                    dataType: "json",
                    contentType: "application/json",
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in DeleteExceptionRule() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    if (!jsonResult.startsWith('INC') && parseInt(jsonResult) >= 0) {
                        GetExceptions();
                        logger.logSuccess('Exception Rule deleted successfully', 'Success', system.getModuleId(BpViewModel), true);
                    }
                    else {
                        if (jsonResult.startsWith('INC')) {
                            logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(BpViewModel), true);
                        }
                        else {
                            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DeleteExceptionRule() method in BlueprintSetup.js';
                            logger.logMessage(msg);
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DeleteExceptionRule() method in BlueprintSetup.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name().toString(), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == ((!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteExceptionRule() method in BlueprintSetup.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteExceptionRule() method in BlueprintSetup.js';
                    logger.logMessage(msg);
                }
            };
        }
        function AddRulePopUp(data, event) {
            try {
                EmptyAllLists();
                $('#CreateNewException').modal('show');
                var i = 0;
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AddRulePopUp() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }
        function EmptyAllLists() {
            BpViewModel.XAxisList([]);
            BpViewModel.YAxisList([]);
            BpViewModel.ZAxisList([]);
            BpViewModel.SupportingXAxisList([]);
            BpViewModel.SupportingYAxisList([]);
            BpViewModel.SupportingZAxisList([]);

            $('#XAxis').multiselect();
            $('#XAxis').multiselect('refresh');
            BpViewModel.SelectedExceptionAssessmentValue('');
        }
        function GetDimensionDetails() {
            try {
                EmptyAllLists();
                BpViewModel.SupportDimensionTypeX_Axis('');
                BpViewModel.SupportDimensionTypeY_Axis('');
                BpViewModel.SupportDimensionTypeZ_Axis('');
                $.ajax({
                    url: "/api/Configuration/GetDimensionDetails",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders(),
                    data: {
                        "DimesnionUid": BpViewModel.SelectedDimensionTypeId()
                    }
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult !== null) {
                            if (jsonResult.Incident_Description != null) {
                                logger.logError(jsonResult.Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(BpViewModel), true);
                            } else {
                                BpViewModel.SupportDimensionTypeX_Axis(jsonResult.SupportXAxisName);
                                BpViewModel.SupportDimensionTypeY_Axis(jsonResult.SupportYAxisName);
                                BpViewModel.SupportDimensionTypeZ_Axis(jsonResult.SupportZAxisName);
                                //change from here
                                var MappedList = $.map(jsonResult.AssessmentTypes, function (result) {
                                    return new AssessmentTypeModel(result);
                                });
                                BpViewModel.DimensionRAT(MappedList);
                            }
                        }
                        return true;
                    })
                    .fail(function (jsonResult, error) {
                        logger.logError((!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchTypeAssessments') == -1) ? (!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchTypeAssessments') == -1) ? 'An error has occurred while fetching the type assessments. Please contact your Administrator.' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchTypeAssessments')].Name() : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchTypeAssessments')].Name(), 'Error', system.getModuleId(BpViewModel), true);
                        return false;
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetDimensionDetails() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function SetExceptionRuleData() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/SetExceptionRuleData",
                    type: "POST",
                    headers: headers,
                    data: {
                        SurveyComponentId: BpViewModel.SelectedExceptionCategoryValue(),
                        AssessmentType: { AssessmentId: BpViewModel.SelectedExceptionAssessmentValue() },
                        Dimension: { DimensionTypeId: BpViewModel.SelectedDimensionTypeId },
                        XAxisValue: BpViewModel.SelectedExceptionXAxisValue().join('|'),
                        YAxisValue: BpViewModel.SelectedExceptionYAxis(),
                        ZAxisValue: BpViewModel.SelectedExceptionZAxis()
                    }
                })
                    .success(function (jsonResult, error) {
                        try {
                            if (!jsonResult.startsWith('INC')) {
                                if (parseInt(jsonResult) >= 1) {
                                    GetExceptions();
                                    logger.logSuccess('Exception has been added Successfully.', 'Success', system.getModuleId(BpViewModel), true);
                                }
                                else if (parseInt(jsonResult) == 0) {
                                    logger.logWarning('Exception(s) already exists.', 'warning', system.getModuleId(BpViewModel), true);
                                }
                            }
                            else {
                                if (jsonResult.startsWith('INC')) {
                                    logger.logError(jsonResult + " - " + 'An error occurred while adding Exception. Please contact your Application Administrator.', 'Error', system.getModuleId(BpViewModel), true);
                                }
                                else {
                                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SetExceptionRuleData() method in BlueprintSetup.js';
                                    logger.logMessage(msg);
                                }
                            }
                        } catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: ajaxFail in SetExceptionRuleData() method in BlueprintSetup.js';
                            logger.logMessage(msg);
                        }
                    })
                    .fail(function (error, status) {
                        logger.logError('An error has occurred while adding Exception. Please contact the Application Administrator.', 'Error', system.getModuleId(BpViewModel), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetExceptionRuleData() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function GetBlueprintFilterData() {
            try {
                $.ajax({
                    url: "/api/Configuration/GetBlueprintFilterData",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(function (jsonResult, error) {
                        BpViewModel.AssessmentTypeListDropDown([]);
                        if (jsonResult !== null) {
                            if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                                logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(BpViewModel), true);
                            }
                            else {
                                var MappedBlueprintFilterData = $.map(jsonResult, function (result) {
                                    return new BlueprintFilterModel(result);
                                });
                                BpViewModel.AssessmentTypeListDropDown(MappedBlueprintFilterData);
                            }
                        }
                        return true;
                    })
                    .fail(function (jsonResult, error) {
                        logger.logError((!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchTypeAssessments') == -1) ? (!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchTypeAssessments') == -1) ? 'An error has occurred while fetching the type assessments. Please contact your Administrator.' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchTypeAssessments')].Name() : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchTypeAssessments')].Name(), 'Error', system.getModuleId(BpViewModel), true);
                        return false;
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetBlueprintFilterData() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function onChangeAssessmentDropDown(data, event) {
            try {
                    BpViewModel.SurveyCategoryListDropDown([]);
                    var NewSurveyCategoryMapping = [];
                    var id = BpViewModel.SelectedAssessmentValue();
                    for (var i = 0; i < BpViewModel.AssessmentTypeListDropDown().length; i++) {
                        if (BpViewModel.AssessmentTypeListDropDown()[i].AssessmentId() == id) {
                            NewSurveyCategoryMapping.push(BpViewModel.AssessmentTypeListDropDown()[i].SurveyCategoryTypes);
                        }
                    } BpViewModel.SurveyCategoryListDropDown(NewSurveyCategoryMapping[0]);
                    BpViewModel.SelectedAssessmentValueName($('#AssesmentType option:selected').text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: onChangeAssessmentDropDown() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }
        function onChangeExceptionAssessmentDropDown(data, event) {
            try {
                BpViewModel.DimensionZAT([]);
                var NewSurveyCategoryMapping;
                var id = BpViewModel.SelectedExceptionAssessmentValue();
                for (var i = 0; i < BpViewModel.DimensionRAT().length; i++) {
                    if (BpViewModel.DimensionRAT()[i].AssessmentId() === id) {
                        NewSurveyCategoryMapping = BpViewModel.DimensionRAT()[i].SurveyCategoryTypes;
                        break;
                    }
                } BpViewModel.DimensionZAT(NewSurveyCategoryMapping);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: onChangeExceptionAssessmentDropDown() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }
        function onChangeExceptionSurveyCategoryDropDown(data, event) {
            try {
                BpViewModel.XAxisList([]);
                BpViewModel.YAxisList([]);
                BpViewModel.ZAxisList([]);
                BpViewModel.SupportingXAxisList([]);
                BpViewModel.SupportingYAxisList([]);
                BpViewModel.SupportingZAxisList([]);
                var id = BpViewModel.SelectedExceptionCategoryValue();
                for (var i = 0; i < BpViewModel.DimensionZAT().length; i++) {
                    if (BpViewModel.DimensionZAT()[i].SurveyCategoryId() === id) {
                        BpViewModel.SupportingXAxisList(BpViewModel.DimensionZAT()[i].Dimension.SupportingXAxisList);
                        BpViewModel.SupportingYAxisList(BpViewModel.DimensionZAT()[i].Dimension.SupportingYAxisList);
                        BpViewModel.SupportingZAxisList(BpViewModel.DimensionZAT()[i].Dimension.SupportingZAxisList);
                        if (BpViewModel.SupportingXAxisList().length === 0) BpViewModel.XAxisList(BpViewModel.DimensionZAT()[i].Dimension.XAxisList);
                        if (BpViewModel.SupportingYAxisList().length === 0) BpViewModel.YAxisList(BpViewModel.DimensionZAT()[i].Dimension.YAxisList);
                        if (BpViewModel.SupportingZAxisList().length === 0) BpViewModel.ZAxisList(BpViewModel.DimensionZAT()[i].Dimension.ZAxisList);

                        break;
                    }
                }
                $('#XAxis').multiselect();
                $('#XAxis').multiselect('refresh');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: onChangeExceptionSurveyCategoryDropDown() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function onChangeExceptionXAxisDropDown(data, event) {
            try {
                BpViewModel.SelectedExceptionXAxisValue(Array.from(document.getElementById('XAxis').querySelectorAll("option:checked"), e => parseInt(e.value)));

                if (BpViewModel.DimensionClass() === "AQ") {
                    BpViewModel.YAxisList([]);
                    var id = BpViewModel.SelectedExceptionCategoryValue();
                    var newList = [];
                    for (let i = 0; i < BpViewModel.DimensionZAT().length; i++) {
                        if (BpViewModel.DimensionZAT()[i].SurveyCategoryId() === id) {
                            newList.push(BpViewModel.DimensionZAT()[i].Dimension.YAxisList);
                            break;
                        }
                    }

                    for (var j = 0; j < BpViewModel.SelectedExceptionXAxisValue().length; j++) {
                        for (let i = 0; i < newList[0].length; i++) {
                            if (BpViewModel.SelectedExceptionXAxisValue()[j] === newList[0][i].ReferenceId()) {
                                BpViewModel.YAxisList.push(newList[0][i]);
                            }
                        }
                    }
                    var a = ko.dependentObservable(function () {
                        var seen = [];
                        return BpViewModel.YAxisList().filter(function (n) {
                            return seen.indexOf(n.AxisId()) === -1 && seen.push(n.AxisId());
                        });
                    });
                    BpViewModel.UniqueYAxisList([]);
                    for (var i = 0; i < a().length; i++) {
                        BpViewModel.UniqueYAxisList.push(a()[i]);
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: onChangeExceptionXAxisDropDown() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function onChangeExceptionSupportingYAxisDropDown(data, event) {
            try {
                BpViewModel.YAxisList([]);
                BpViewModel.XAxisList([]);
                var id = BpViewModel.SelectedExceptionCategoryValue();
                var newList = [];
                var newListXAxis = [];
                for (let i = 0; i < BpViewModel.DimensionZAT().length; i++) {
                    if (BpViewModel.DimensionZAT()[i].SurveyCategoryId() === id) {
                        newList.push(BpViewModel.DimensionZAT()[i].Dimension.YAxisList);
                        newListXAxis.push(BpViewModel.DimensionZAT()[i].Dimension.XAxisList);
                        break;
                    }
                }

                for (let i = 0; i < newList[0].length; i++) {
                    if (BpViewModel.SelectedExceptionSupportingYAxisValue() === newList[0][i].ReferenceId()) {
                        BpViewModel.YAxisList.push(newList[0][i]);
                    }
                }

                var UniqueXAxisList = [];
                for (let k = 0; k < newListXAxis[0].length; k++) {
                    if (BpViewModel.SelectedExceptionSupportingYAxisValue() === newListXAxis[0][k].ReferenceId()) {
                        UniqueXAxisList.push(newListXAxis[0][k]);
                    }
                }

                BpViewModel.XAxisList(UniqueXAxisList);
                $('#XAxis').multiselect();
                $('#XAxis').multiselect('refresh');

                var a = ko.dependentObservable(function () {
                    var seen = [];
                    return BpViewModel.YAxisList().filter(function (n) {
                        return seen.indexOf(n.AxisId()) === -1 && seen.push(n.AxisId());
                    });
                });
                BpViewModel.UniqueYAxisList([]);
                for (var i = 0; i < a().length; i++) {
                    BpViewModel.UniqueYAxisList.push(a()[i]);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: onChangeExceptionSupportingYAxisDropDown() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function onChangeSurveyCategoryDropDown(data, event) {
            try {
                BpViewModel.MatrixTypeListDropDown([]);
                BpViewModel.AreasListDropDown([]);
                BpViewModel.BusinessUnitListDropDown([]);
                var NewMatrixTypeMapping = [];
                var id = BpViewModel.SelectedAssessmentValue();
                for (var i = 0; i < BpViewModel.AssessmentTypeListDropDown().length; i++) {
                    if (BpViewModel.AssessmentTypeListDropDown()[i].AssessmentId() == id) {
                        NewMatrixTypeMapping.push(BpViewModel.AssessmentTypeListDropDown()[i].MatrixTypes);
                    }
                }
                BpViewModel.MatrixTypeListDropDown(NewMatrixTypeMapping[0]);

                var NewAreaMapping = [];
                var id = BpViewModel.SelectedCategoryValue();

                for (var i = 0; i < BpViewModel.SurveyCategoryListDropDown().length; i++) {
                    if (BpViewModel.SurveyCategoryListDropDown()[i].SurveyCategoryId() == id) {
                        NewAreaMapping.push(BpViewModel.SurveyCategoryListDropDown()[i].Areas);
                    }
                }
                BpViewModel.AreasListDropDown(NewAreaMapping[0]);

                var NewBusinessUnitMapping = [];
                var id = BpViewModel.SelectedAssessmentValue();
                for (var i = 0; i < BpViewModel.AssessmentTypeListDropDown().length; i++) {
                    if (BpViewModel.AssessmentTypeListDropDown()[i].AssessmentId() == id) {
                        NewBusinessUnitMapping.push(BpViewModel.AssessmentTypeListDropDown()[i].BusinessUnitModels);
                    }
                }
                BpViewModel.BusinessUnitListDropDown(NewBusinessUnitMapping[0]);
                BpViewModel.SelectedCategoryValueName($('#SurveyComponent option:selected').text());
                $('#ApplicableBUDropdown').multiselect('refresh');
                $('#ApplicableAreaDropdown').multiselect('refresh');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: onChangeSurveyCategoryDropDown() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function onChangeMatrixTypeDropDown() {
            BpViewModel.SelectedMatrixTypeName($('#MatrixType option:selected').text());
        }

        function ApplyBlueprintFilter() {
            BpViewModel.SelectedBUList(Array.from(document.getElementById('ApplicableBUDropdown').querySelectorAll("option:checked"), e => e.value).join(", "));
            BpViewModel.SelectedAreaList(Array.from(document.getElementById('ApplicableAreaDropdown').querySelectorAll("option:checked"), e => e.value).join(", "));
            $("#Blueprint_Notification").hide();
            $("#BP_NOTI").css("display", "block");
            GetMappedAreasBusinessUnits();
        }

        function GetMappedAreasBusinessUnits() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Configuration/GetMappedBusinessUnitAreas",
                    type: "GET",
                    headers: headers,
                    data: {
                        "AssessmentId": BpViewModel.SelectedAssessmentValue(),
                        "SurveyCategoryId": BpViewModel.SelectedCategoryValue(),
                        "BusinessUnitIds": BpViewModel.SelectedBUList().toString(),
                        "AreasId": BpViewModel.SelectedAreaList().toString()
                    }
                })
                    .success(function (jsonResult, error) {
                        try {
                            BpViewModel.PreviouslyValuesSet(false);
                            if (jsonResult != null) {
                                if (jsonResult.Incident_Description != null) {
                                    logger.logError(jsonResult.Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(BpViewModel), true);
                                }
                                else {
                                    var MappedBusinessUnitListObj = $.map(jsonResult.businessUnit, function (result) {
                                        return new BusinessUnitListModel(result);
                                    });
                                    var MappedSubAreaListObj = $.map(jsonResult.subAreaUnit, function (result) {
                                        return new SubAreaListModel(result);
                                    });
                                    var MappedSubAreaListSelectedObj = $.map(jsonResult.previousUploadGridData, function (result) {
                                        return new SubAreaListSelectedModel(result);
                                    });
                                    if (MappedSubAreaListSelectedObj != undefined && MappedSubAreaListSelectedObj.length > 0) {
                                        BpViewModel.PreviouslyValuesSet(true);
                                    }
                                }
                            }

                            BpViewModel.BlueprintDataList([]);
                            BpViewModel.BusinessUnitList([]);
                            BpViewModel.SubAreaList([]);
                            BpViewModel.SubAreaListSelected([]);
                            BpViewModel.BusinessUnitList(MappedBusinessUnitListObj);
                            BpViewModel.SubAreaList(MappedSubAreaListObj);
                            BpViewModel.SubAreaListSelected(MappedSubAreaListSelectedObj);

                            if ($.fn.DataTable.isDataTable('#tblBlueprintSetup1')) {
                                var tableObj = $('#tblBlueprintSetup1').DataTable();
                                tableObj.destroy();
                                $('#tblBlueprintSetup1 tbody tr').remove();
                                $('#tblBlueprintSetup1 thead #blueprint_column_header_1').empty();
                                var htmlHeaders = "";
                                htmlHeaders += '<th style="width:12% !important"><i class="fa fa-arrow-down"></i> Business Units / Areas <i class="fa fa-arrow-right"></i></th>'
                                for (var i = 0; i < BpViewModel.SubAreaList().length; i++) {
                                    htmlHeaders += '<th class="text-left noSort long header-ellipsis" title= "' + BpViewModel.SubAreaList()[i].SUB_AREA_NAME() + '" id= "' + BpViewModel.SubAreaList()[i].SUB_AREA_ID() + '">' + BpViewModel.SubAreaList()[i].SUB_AREA_NAME() + '</th>'
                                }
                                $("#blueprint_column_header_1").append(htmlHeaders);
                            }

                            // FOR ROWDATA
                            if (BpViewModel.PreviouslyValuesSet()) {
                                var mappedList = ko.observableArray();
                                for (var i = 0; i < BpViewModel.BusinessUnitList().length; i++) {
                                    var riskThemeData = ko.utils.arrayFilter(BpViewModel.SubAreaListSelected(), function (parameter) {
                                        if (parameter.BU_UID() == BpViewModel.BusinessUnitList()[i].BU_UID())
                                            return true;
                                        else
                                            return false;
                                    });
                                    mappedList.push(new AreaModel({ 'BU_UID': riskThemeData[0].BU_UID(), 'BU_NAME': riskThemeData[0].BU_NAME(), 'rowData': riskThemeData }));
                                }
                                BpViewModel.BlueprintDataList(mappedList());
                            }
                            MapBlueprintDataList();
                        }
                        catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: GetMappedAreasBusinessUnits() method in BlueprintSetup.js';
                            logger.logMessage(msg);
                        }
                    })
                    .fail(function (error, status) {
                        logger.logError((!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchTypeAssessments') == -1) ? 'An error has occurred while fetching the type assessments. Please contact your Administrator.' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFetchTypeAssessments')].Name(), 'Error', system.getModuleId(BpViewModel), true);
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetMappedAreasBusinessUnits() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function MapBlueprintDataList() {
            try {
                var oTable = $('#tblBlueprintSetup1').DataTable(
                    {
                        'aoColumnDefs': [{
                            'bSortable': false,
                            "targets": "_all"
                        }],
                        "aaSorting": [],
                        scrollY: "380px",
                        scrollX: true,
                        paging: false,
                        bFilter: true,
                        "bInfo": false,
                        fixedColumns: {
                            leftColumns: 1
                        },
                        fixedheader: {
                            header: true
                        },
                        destroy: true
                    });
                $('#tblBlueprintSetup1').closest(".dataTables_wrapper").find("*").css("box-sizing", "content-box").css("-moz-box-sizing", "content-box");

                $('#myInputTextField').keyup(function () {
                    oTable.search($(this).val()).draw();
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: MapBlueprintDataList() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }
        // Blueprint Filter - Ends

        // Blueprint Excel - Starts
        function downloadDocuments(data, event) {
            try {
                //BU vs Areas
                var payLoad = {
                    t: appsecurity.getAuthenticationInfo(), AssessmentId: BpViewModel.SelectedAssessmentValue(), SurveyCategoryId: BpViewModel.SelectedCategoryValue(), SurveyName: (BpViewModel.SelectedAssessmentValueName()+'_'+BpViewModel.SelectedCategoryValueName()),
                };
                utils.postAndRedirect(rootPath + "/FileDownload/DownloadExcelTemplateBA", payLoad, '_blank');
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | downloadDocuments() in Blueprint.js';
                logger.logMessage(msg);
            }
        }

        function uploadDownloadTemplate(data, event) {
            try {
                $('#uploadDownloadPopup').modal('show');
                document.getElementById('valfactorerror').innerHTML = "";
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: uploadDownloadTemplate() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function uploadDocumentBtn() {
            try {
                var FileList = document.getElementById('FileUploader').files;
                if (FileList.length > 0) {
                    var FileName = document.getElementById('FileUploader').files[0].name;
                    if (FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLSX' || FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLSM') {
                        if (FileList[0].size <= 1073741824) {
                            document.getElementById('valfactorerror').innerHTML = "";
                            var FormDataObj = new FormData();
                            FormDataObj.append("File1", FileList[0]);
                            var request = new XMLHttpRequest();

                            request.onreadystatechange = function () {
                                if (request.readyState == 1) {
                                    document.getElementById('valfactorerror').innerHTML = "Initializing File Upload...";
                                    $('#valfactorerror').show();
                                }
                                else if (request.readyState == 4) {
                                    if (request.status == 200) {
                                        if (request.responseText != null && request.responseText != "" && request.responseText != "null") {
                                            document.getElementById('FileUploader').value = null;
                                            if (request.responseText == "2" || request.responseText == "-1") {
                                                document.getElementById('valfactorerror').innerHTML = (!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFileUpload') == -1) ? 'Error in file upload!' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorFileUpload')].Name();
                                                logger.logWarning((!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExcelFormatMismatch') == -1) ? 'Excel format mismatch! Please check and try again.' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExcelFormatMismatch')].Name(), 'Warning', system.getModuleId(BpViewModel), true);
                                                $('#valfactorerror').show();
                                            }
                                            else {
                                                document.getElementById('valfactorerror').innerHTML = (!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileUploadSuccessMessage') == -1) ? 'The file has been uploaded successfully.' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileUploadSuccessMessage')].Name();
                                                logger.logSuccess((!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('MatrixUploadSuccessMsg') == -1) ? 'Matrix uploaded successfully.' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('MatrixUploadSuccessMsg')].Name(), 'Success', system.getModuleId(BpViewModel), true);
                                                GetMappedAreasBusinessUnits();
                                            }
                                        }
                                        else {
                                            document.getElementById('valfactorerror').innerHTML = (!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CantUploadFileErrorMessage') == -1) ? 'The file could not be uploaded.' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CantUploadFileErrorMessage')].Name();
                                            logger.logError((!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorReportUpload') == -1) ? 'Some error occured while uploading report.' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorReportUpload')].Name(), 'Error', system.getModuleId(BpViewModel), true);
                                            $('#valfactorerror').show();
                                            document.getElementById('FileUploader').value = null;
                                        }
                                    }
                                    else
                                        ajaxFail(request, "");
                                }
                            };
                            request.upload.addEventListener('progress', function (event) {
                                document.getElementById('valfactorerror').innerHTML = (!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('UploadingFileStatusMessage') == -1) ? 'Uploading File...' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('UploadingFileStatusMessage')].Name();
                            });
                            request.withCredentials = true;
                            var apiString = "/api/Survey/UploadExcelTemplate?SurveyCategory=" + BpViewModel.SelectedCategoryValue() + "&AssessmentCategory=" + BpViewModel.SelectedAssessmentValue() + "&SurveyType=" + BpViewModel.SelectedCategoryValueName();

                            request.open('POST', apiString);
                            var csrfToken = $("input[name='__RequestVerificationToken']").val();
                            var headers = appsecurity.getSecurityHeaders();
                            headers.__RequestVerificationToken = csrfToken;
                            request.setRequestHeader('Authorization', headers.Authorization);
                            request.setRequestHeader('RT', headers.RT);
                            request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                            request.send(FormDataObj);
                        }
                        else {
                            document.getElementById('FileUploader').value = null;
                            logger.logError(((!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileSizeLimitMessageBegin') == -1) ? 'Upload file size cannot exceed' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileSizeLimitMessageBegin')].Name()).toString() + ' ' + (BpViewModel.UploadFileSize() / 1048576) + (BpViewModel.UploadFileSize() / 1048576) + ' ' + ((!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileSizeLimitMessageEnd') == -1) ? 'MB. Please try uploading a file of lesser size.' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FileSizeLimitMessageEnd')].Name()).toString(), 'Error', system.getModuleId(BpViewModel), true);
                        }
                    }
                    else {
                        document.getElementById('FileUploader').value = null;
                        logger.logError((!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ValidFileFormatMessage') == -1) ? 'Please select valid file to upload.' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ValidFileFormatMessage')].Name(), 'Error', system.getModuleId(BpViewModel), true);
                    }
                }
                else {
                    document.getElementById('FileUploader').value = null;
                    logger.logError((!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ValidFileFormatMessage') == -1) ? 'Please select valid file to upload.' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ValidFileFormatMessage')].Name(), 'Error', system.getModuleId(BpViewModel), true);
                }
                function ajaxFail(error, status) {
                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then()
                        }
                        else {
                            var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in UploadDocument() method in Blueprint.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadDocument() method in Blueprint.js';
                        logger.logMessage(msg);
                    }
                };
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadExcelDocument() method in Blueprint.js';
                logger.logMessage(msg);
            }
        }

        /*===========================================Modal Begin Here==============================================*/
        function BusinessUnitListModel(item) {
            try {
                var self = this;
                self.BU_UID = ko.observable(item.BU_UID);
                self.BU_NAME = ko.observable($('<div/>').html(item.BU_NAME).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessUnitListModel() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function SubAreaListModel(item) {
            try {
                var self = this;
                self.SUB_AREA_ID = ko.observable(item.SUB_AREA_ID);
                self.SUB_AREA_NAME = ko.observable($('<div/>').html(item.SUB_AREA_NAME).text());
                self.PARENT_AREA_ID = ko.observable(item.PARENT_AREA_ID);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SubAreaListModel() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function SubAreaListSelectedModel(item) {
            try {
                var self = this;
                self.SUB_AREA_UID = ko.observable(item.SUB_AREA_UID);
                self.SUB_AREA_NAME = ko.observable($('<div/>').html(item.SUB_AREA_NAME).text());
                self.OPTION_NAME = ko.observable($('<div/>').html(item.OPTION_NAME).text());
                self.QUESTION_UID = ko.observable(item.QUESTION_UID);
                self.QUESTION_SHORT = ko.observable($('<div/>').html(item.QUESTION_SHORT).text());
                self.BU_UID = ko.observable(item.BU_UID);
                self.BU_NAME = ko.observable($('<div/>').html(item.BU_NAME).text());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SubAreaListSelectedModel() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function AreaModel(item) {
            try {
                var self = this;
                self.BU_UID = ko.observable(item.BU_UID);
                self.BU_NAME = ko.observable($('<div/>').html(item.BU_NAME).text());
                self.QUESTION_UID = ko.observable(item.QUESTION_UID);
                self.QUESTION_NAME = ko.observable($('<div/>').html(item.QUESTION_NAME).text());
                self.rowData = item.rowData;
            }
            catch (e) {
                var msg = 'exception' + e + 'source: AreaModel() in AmlControlRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        //Dimension Related models
        function AssessmentTypeModel(item) {
            try {
                this.AssessmentId = ko.observable(item.AssessmentId);
                this.AssessmentName = ko.observable(item.AssessmentName);

                if (item.SurveyComponents !== undefined && item.SurveyComponents !== null) {
                    var MappedSurveyCategoryModel = $.map(item.SurveyComponents, (result) => {
                        return new SurveyCategoryModel(result);
                    });
                    this.SurveyCategoryTypes = MappedSurveyCategoryModel;
                }
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: AssessmentTypeModel() in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }
        function SurveyCategoryModel(item) {
            try {
                var self = this;
                self.SurveyCategoryId = ko.observable(item.SurveyCategoryId);
                self.SurveyCategoryName = ko.observable(item.SurveyCategoryName);
                self.SurveyGroupShortName = ko.observable(item.SurveyGroupShortName);
                self.LaunchFlag = ko.observable(item.LaunchFlag);
                if (item.Dimension !== undefined && item.Dimension !== null) {
                    this.Dimension = new DimensionModel(item.Dimension);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyCategoryModel() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }
        function DimensionModel(item) {
            try {
                if (item.XAxisList !== undefined && item.XAxisList !== null) {
                    let MappedList = $.map(item.XAxisList, (result) => {
                        return new AxisModel(result);
                    });
                    this.XAxisList = MappedList;
                }
                if (item.YAxisList !== undefined && item.YAxisList !== null) {
                    let MappedList = $.map(item.YAxisList, (result) => {
                        return new AxisModel(result);
                    });
                    this.YAxisList = MappedList;
                }
                if (item.ZAxisList !== undefined && item.ZAxisList !== null) {
                    let MappedList = $.map(item.ZAxisList, (result) => {
                        return new AxisModel(result);
                    });
                    this.ZAxisList = MappedList;
                }
                if (item.SupportingXAxisList !== undefined && item.SupportingXAxisList !== null) {
                    let MappedList = $.map(item.SupportingXAxisList, (result) => {
                        return new AxisModel(result);
                    });
                    this.SupportingXAxisList = MappedList;
                }
                if (item.SupportingYAxisList !== undefined && item.SupportingYAxisList !== null) {
                    let MappedList = $.map(item.SupportingYAxisList, (result) => {
                        return new AxisModel(result);
                    });
                    this.SupportingYAxisList = MappedList;
                }
                if (item.SupportingZAxisList !== undefined && item.SupportingZAxisList !== null) {
                    let MappedList = $.map(item.SupportingZAxisList, (result) => {
                        return new AxisModel(result);
                    });
                    this.SupportingZAxisList = MappedList;
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DimensionModel() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }
        function AxisModel(item) {
            try {
                var self = this;
                self.AxisId = ko.observable(item.AxisId);
                self.AxisName = ko.observable($('<div/>').html(item.AxisName).text());
                self.ReferenceId = ko.observable(item.ReferenceId);
            }
            catch (e) {
                var msg = 'exception' + e + 'source: AxisModel() in AmlControlRiskHeatMap.js';
                logger.logMessage(msg);
            }
        }

        // Blueprint Filter - Starts
        function BlueprintFilterModel(item) {
            try {
                this.AssessmentId = ko.observable(item.AssessmentId);
                this.AssessmentName = ko.observable(item.AssessmentName);
                this.AssessmentDisplayName = ko.observable(item.AssessmentDisplayName);
                this.Description = ko.observable(item.Description);

                if (item.SurveyCategoryModels !== undefined && item.SurveyCategoryModels !== null) {
                    var MappedSurveyCategoryModel = $.map(item.SurveyCategoryModels, (result) => {
                        return new SurveyCategoryListModel(result);
                    });
                    this.SurveyCategoryTypes = MappedSurveyCategoryModel;
                }

                if (item.BusinessUnitModels !== undefined && item.BusinessUnitModels !== null) {
                    var MappedBusinessUnit = $.map(item.BusinessUnitModels, (result) => {
                        return new BusinessUnitModel(result);
                    });
                    this.BusinessUnitModels = MappedBusinessUnit;
                }
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: MappedBlueprintFilterData() in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function SurveyCategoryListModel(item) {
            try {
                var self = this;
                self.SurveyCategoryId = ko.observable(item.SurveyCategoryId);
                self.SurveyCategoryName = ko.observable(item.SurveyCategoryName);
                self.SurveyGroupId = ko.observable(item.SurveyGroupId);
                self.SurveyGroupShortName = ko.observable(item.SurveyGroupShortName);
                if (item.AreaModels !== undefined && item.AreaModels !== null) {
                    var MappedAreas = $.map(item.AreaModels, (result) => {
                        return new AreaListModel(result);
                    });
                    self.Areas = MappedAreas;
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyCategoryListModel() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function BusinessUnitModel(item) {
            try {
                var self = this;
                self.BU_UID = ko.observable(item.BusinessUnitId);
                self.BU_NAME = ko.observable(item.BusinessUnitName);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: BusinessUnitModel() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function AreaListModel(item) {
            try {
                var self = this;
                self.AreaId = ko.observable(item.AreaId);
                self.AreaName = ko.observable(item.AreaName);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: AreaListModel() in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        // Blueprint Filter - Ends

        //Apply Blueprint

        function consentCheck(data) {
            app.showMessage("<b> By clicking the Confirm button, I acknowledge the following: </b> \n <br> 1. I have reviewed the Blueprint changes including Obligation Matrix and Dimensions (if any). \n <br> 2. I have reviewed the list of changes in the attached tracker before proceeding. \n <br> 3. I understand that upon executing the blueprint changes the response(s)/document(s) are cleared for deleted surveys. \n <br> 4. I understand that weights need to be adjusted based on changes in the Blueprint Module. \n <br> <b> Review the list of changes before proceeding with these changes. </b> \n <br> <b> If you do not wish to proceed, please Cancel. </b> ", "Acknowledgement", ["Confirm", "Cancel"], true, { buttonClass: "fa fa-check btn btn-primary", primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-copy' })
                .then(function (option) {
                    if (option == 'Confirm') {
                        if (BpViewModel.SelectedSurveyComponent()[0] != undefined)
                            applyBlueprintSetup(data)
                        else {
                            document.getElementById('blueprintpopupvalidation').innerHTML = "Please select a survey component.";
                            logger.logError((!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SCNameValidation') == -1) ? 'Please select a survey component to proceed.' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SCNameValidation')].Name(), 'Error', system.getModuleId(BpViewModel), true);
                        }
                    }
                });
        }

        function OnChangeSurveyComponent(data, event) {
            try {
                BpViewModel.IsLaunchedFlag(false);
                for (var i = 0; i < BpViewModel.SurveyTypesList().length; i++) {
                    if (BpViewModel.SelectedSurveyComponent()[0] === BpViewModel.SurveyTypesList()[i].SurveyCategoryId()) {
                        if (BpViewModel.SurveyTypesList()[i].LaunchFlag() === 1) {
                            BpViewModel.IsLaunchedFlag(true);
                            break;
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: OnChangeSurveyComponent() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function NavigateToSSRSBPChangeReport() {
            try {
                var payLoad = {
                    t: appsecurity.getAuthenticationInfo(), SurveyComponent: BpViewModel.SelectedSurveyComponent()[0]
                };
                utils.postAndRedirect(rootPath + "/FileDownload/ExportBPChange", payLoad, '_blank');
                $('#loadingImgMainHm').modal('hide');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateToSSRSBPChangeReport() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function applyBlueprintSetup(data) {
            try {
                document.getElementById('blueprintpopupvalidation').innerHTML = "Applying Blueprint...";
                $('#blueprintpopupvalidation').show();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/Survey/ApplyBluePrint?SurveyCategoryId=" + parseInt(BpViewModel.SelectedSurveyComponent()[0]),
                    type: "POST",
                    headers: headers
                })
                    .success(function (jsonResult, success) {
                        if (jsonResult == null) {
                            logger.logError('Please Configure ' + BpViewModel.BUTitle() + '.', 'Error', system.getModuleId(AMLRaViewModel), true);
                        }
                        else if (!jsonResult.startsWith('INC')) {
                            if (parseInt(jsonResult) > 0) {
                                document.getElementById('blueprintpopupvalidation').innerHTML = "Blueprint Matrix has been applied successfully.";
                                logger.logSuccess((!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ApplicabilityMatrixSuccessMsg') == -1) ? 'Applicability Matrix has been applied successfully.' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ApplicabilityMatrixSuccessMsg')].Name(), 'Success', system.getModuleId(BpViewModel), true);
                                $('#ApplyBlueprintPopup').modal('hide');
                                $('body').removeClass('modal-open');
                                $('.modal-backdrop').remove();
                                GetAllSurveyType();
                            }
                            else {
                                document.getElementById('blueprintpopupvalidation').innerHTML = "An error has occurred.";
                                logger.logError((!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg') == -1) ? 'An error has occurred. Please contact your Application Administrator.' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg')].Name(), 'Error', system.getModuleId(BpViewModel), true);
                            }
                        }
                        else {
                            if (jsonResult.startsWith('INC')) {
                                logger.logError(jsonResult + " - " + 'An error occurred while adding Exception. Please contact your Application Administrator.', 'Error', system.getModuleId(BpViewModel), true);
                            }
                            else {
                                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in applyBlueprintSetup() method in BlueprintSetup.js';
                                logger.logMessage(msg);
                            }
                        }
                    })
                    .fail(function (error, fail) {
                        document.getElementById('blueprintpopupvalidation').innerHTML = "An error has occurred.";
                        logger.logError((!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg') == -1) ? 'An error has occurred. Please contact your Application Administrator.' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg')].Name(), 'Error', system.getModuleId(BpViewModel), true);
                    })
            }
            catch (e) {
                document.getElementById('blueprintpopupvalidation').innerHTML = "An error has occurred.";
                var msg = 'Exception: ' + e + ' | Source: applyBlueprintSetup() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }
        function ApplyBlueprintPopup() {
            try {
                BpViewModel.SelectedSurveyComponent([]);
                BpViewModel.IsLaunchedFlag(false);
                $('#blueprintpopupvalidation').hide();
                $('#ApplyBlueprintPopup').modal('show');
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ApplyBlueprintPopup() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        function DimensionTypeModel(item) {
            try {
                var self = this;
                self.DimensionTypeId = ko.observable(item.DimensionTypeId);
                self.DimensionTypeName = ko.observable(item.DimensionTypeName);
                self.DimensionClass = ko.observable(item.DimensionClass);
                self.XAxisName = ko.observable(item.XAxisName);
                self.YAxisName = ko.observable(item.YAxisName);
                self.ZAxisName = ko.observable(item.ZAxisName);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DimensionTypeModel() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }
        function ExceptionModel(item) {
            try {
                var self = this;
                self.ExceptionId = ko.observable(item.ExceptionId);
                self.AssessmentType = ko.observable(item.AssessmentType.AssessmentName);
                self.SurveyComponent = ko.observable(item.SurveyComponent);
                self.XAxisDescription = ko.observable(item.XAxisDescription);
                self.YAxisDescription = ko.observable(item.YAxisDescription);
                self.ZAxisDescription = ko.observable(item.ZAxisDescription);
                self.CreatedBy = ko.observable(item.CreatedBy);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ExceptionModel() method in BlueprintSetup.js';
                logger.logMessage(msg);
            }
        }

        //function to get all surveys Types
        function GetAllSurveyType() {
            try {
                return $.ajax({
                    url: "/api/Survey/GetSurveyTypes",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax caLL in GetAllSurveyType() in ConfigureSurvey.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        if (jsonResult.length > 0 && jsonResult[0].SurveyGroupFullName != null) {
                            logger.logError(jsonResult[0].SurveyGroupFullName + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(BpViewModel), true);
                        } else {
                            var mappedSurvey = $.map(jsonResult, function (result) {
                                return new SurveyCategoryModel(result);
                            });
                            BpViewModel.SurveyTypesList(mappedSurvey);
                        }
                    }
                    else
                        logger.logError((!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg') == -1) ? 'An error has occurred. Please contact your Application Administrator.' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ErrorOccurredMsg')].Name(), 'Error', system.getModuleId(BpViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllSurveyType() in BlueprintSurvey.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage((!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name, (!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage') == -1) ? 'Error in Edit Operation' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditOperationErrorMessage')].Name, [(!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === ((!BpViewModel.LocaleCheckFlag() || BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword') == -1) ? 'OK' : BpViewModel.ObjGeneralSettings.LocalizedTextList()[BpViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('OkKeyword')].Name).toString())
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllSurveyType() method in BlueprintSurvey.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllSurveyType() method in BlueprintSurvey.js';
                    logger.logMessage(msg);
                }
            }
        }
        //Funciton to get all survey types ends here
    });
